function createMiddlewarePipeline(context, middleware) {
  return middleware.reduce((chain, guard) => {
    return chain.then(result => {
      if (result === true || result === undefined) {
        return guard(context);
      }

      return result;
    });
  }, Promise.resolve(true));
}

export default createMiddlewarePipeline;
